import LocalizedStrings from "react-localization";

export const poolMetadataStrings = new LocalizedStrings({
  en: {
    metadataTitle: "Metadata",
    id: "ID",
    date: "Date",
    socialAccountName: "Social account name",
    mediaChannel: "Media channel",
    link: "Link",
    description: "Description",
  },
  fr: {
    metadataTitle: "Metadata",
    id: "ID",
    date: "Date",
    socialAccountName: "Nom du Social Account",
    mediaChannel: "Support",
    link: "Link",
    description: "Description",
  },
});
